import {combineReducers, configureStore} from "@reduxjs/toolkit";
import appReducer from "./app/Slice";
import authReducer from "./auth/Slice";
import categoryReducer from "./category/Slice";
import wishReducer from "./wish/Slice";
import homeReducer from "./home/Slice";
import leaderboardReducer from "./leaderboard/Slice";
import dashboardReducer from "./dashboard/Slice";
import ticketReducer from "./ticket/Slice";
import howItWorksReducer from "./how-it-works/Slice";
import contactReducer from "./contact/Slice";
import blogReducer from "./blog/Slice";
import wishlistReducer from "./wishlist/Slice"
import notificationReducer from "./notification/Slice";
import userReducer from "./user/Slice";
import partnersReducer from "./partners/Slice";
import documentReducer from "./document/Slice";
import expenseReducer from "./expense/Slice";
import imageReducer from "./image/Slice";
import questionReducer from "./question/Slice";
import cfgAttributeReducer from "./cfg-attribute/Slice";
import faqReducer from "./faq/Slice";
import clientReducer from "./client/Slice";
import wishCodeReducer from "./wish-code/Slice";

import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";

const rootReducer = combineReducers({
    appReducer,
    authReducer,
    categoryReducer,
    wishReducer,
    homeReducer,
    dashboardReducer,
    leaderboardReducer,
    ticketReducer,
    howItWorksReducer,
    contactReducer,
    blogReducer,
    wishlistReducer,
    notificationReducer,
    userReducer,
    partnersReducer,
    documentReducer,
    expenseReducer,
    imageReducer,
    questionReducer,
    cfgAttributeReducer,
    faqReducer,
    clientReducer,
    wishCodeReducer
})

const isProd = process.env.NODE_ENV === 'production';

export const store = configureStore({
    reducer: rootReducer,
    devTools: !isProd,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
        }),
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppDispatch = () => useDispatch<AppDispatch>()
